import React from "react";

const DownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30">
    <path fill="#d91f1f" d="M20.769 18.504l-1.918-.564a.34.34 0 10-.192.65l2.885.85a.34.34 0 00.435-.326v-3.055a.34.34 0 00-.679 0v2.022l-4.138-5.617a.34.34 0 00-.572.039l-1.783 3.27-3.756-5.008a.34.34 0 00-.543.407l4.073 5.43a.34.34 0 00.569-.04l1.781-3.266z"/>
    <path fill="none" stroke="#d91f1f" stroke-miterlimit="20" d="M20.769 18.504v0l-1.918-.564a.34.34 0 10-.192.65l2.885.85a.34.34 0 00.435-.326v-3.055a.34.34 0 00-.679 0v2.022l-4.138-5.617a.34.34 0 00-.572.039l-1.783 3.27v0l-3.756-5.008a.34.34 0 00-.543.407l4.073 5.43a.34.34 0 00.569-.04l1.781-3.266v0z"/>
  </svg>
)

export default DownIcon;
